
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 15.7 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.842 4.057h1.823m12.24 0h-1.693m-2.343 0V.842h-5.99v3.215m5.99 0h-5.99m5.99 0h2.343m-8.333 0H2.665m0 0v10.848h10.547V4.057M6.051 7.539l1.823 1.808m1.823 1.808L7.874 9.347m0 0l1.823-1.808-3.646 3.616","stroke":"currentColor","stroke-width":"1.684","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    